import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'

import GroupedCommunication from '../sections/communication/components/grouped-communication'
import createStore from '../sections/communication/store'
import { startOnce } from '@app/adapters/tutorial'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour~='grouped-communication']").each(function () {
    const data = $(this).data()
    const endpointParams = {
      ledgerId: data.ledgerId,
      contextType: data.contextType,
      contextId: data.contextId,
    }

    const groupCommunicationApp = createApp(GroupedCommunication)
    groupCommunicationApp.use(createStore(endpointParams))
    groupCommunicationApp.mount(this)

    /* TODO: Manually trigger the corresponding Userlane tutorial until they fix their JS performance
    See https://gitlab.silverfin.com/development/silverfin/-/issues/18067 */
    if (typeof this.dataset.tutorialId !== 'undefined') {
      startOnce(this.dataset.tutorialId)
    }
  })
})
